<div class="confirmation-container">
    <div class="w-full flex-column align-items-center">
        <div style="max-width: 768px; width: 100%; margin: 0 auto;">

            <!-- Next Steps Section -->
            <p-card styleClass="confirmation-card mb-4">
                <div class="next-steps">
                    <h3 class="font-medium mb-3 text-lg flex align-items-center gap-2">
                        <i class="pi pi-list"></i>
                        Next Steps
                    </h3>
                    <ul class="steps-list pl-4">
                        <li class="flex gap-3 mb-3">
                            <div class="step-number flex align-items-center justify-content-center flex-shrink-0"
                                style="width: 32px; height: 32px; background-color: #3b82f6; color: white; border-radius: 50%; font-weight: bold;">
                                1</div>
                            <div>
                                <p class="font-semibold mb-1">Review your confirmation email with test access details
                                </p>
                                <p class="text-sm text-500">Check your inbox for detailed instructions</p>
                            </div>
                        </li>
                        <li class="flex gap-3 mb-3">
                            <div class="step-number flex align-items-center justify-content-center flex-shrink-0"
                                style="width: 32px; height: 32px; background-color: #3b82f6; color: white; border-radius: 50%; font-weight: bold;">
                                2</div>
                            <div>
                                <p class="font-semibold mb-1">Navigate to the test launch page when ready to begin</p>
                                <p class="text-sm text-500">Make sure you have a stable internet connection</p>
                            </div>
                        </li>
                        <li class="flex gap-3">
                            <div class="step-number flex align-items-center justify-content-center flex-shrink-0"
                                style="width: 32px; height: 32px; background-color: #3b82f6; color: white; border-radius: 50%; font-weight: bold;">
                                3</div>
                            <div>
                                <p class="font-semibold mb-1">Complete the assessment in a quiet, distraction-free
                                    environment</p>
                                <p class="text-sm text-500">Allocate {{ paymentConfirmation?.orderSummary?.duration }}
                                    for the
                                    test</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="action-buttons flex flex-column gap-2 mt-4">
                    <p-button label="Go to Test Launch" icon="pi pi-play-circle" iconPos="right"
                        (click)="onGoToTestLaunch()"
                        styleClass="p-button-lg p-button-primary w-full launch-test-btn"></p-button>
                </div>
            </p-card>


            <p-card id="receiptPdfArea" styleClass="confirmation-card">
                <div
                    class="receipt-header flex justify-content-between align-items-center mb-4 pb-3 border-bottom-1 border-bluegray-100">
                    <div class=" flex flex-column gap-2 align-items-start">
                        <h2 class="text-3xl font-medium">Order Receipt</h2>
                        <p class="text-sm ">{{ paymentConfirmation?.orderId }}</p>
                    </div>
                    <div class="text-right flex flex-column gap-2 align-items-end">
                        <span class="paid-badge px-3 py-2 border-round font-medium"
                            style="background-color: #22c55e; color: white;">PAID</span>
                        <p class="text-sm ">{{ paymentConfirmation?.orderDate }}</p>
                    </div>
                </div>

                <div class="grid mb-4">
                    <div class="col-12 md:col-6">
                        <h3 class="font-semibold mb-3">Billing Information</h3>
                        <div class="info-section flex flex-column gap-3">
                            <div class="flex flex-column gap-2">
                                <p class="text-left text-sm font-normal" style="color:#808080">Name</p>
                                <p class="text-left text-base font-medium" style="color:#101010">{{
                                    paymentConfirmation?.billingInfo?.fullName }} </p>
                            </div>
                            <div class="flex flex-column gap-2">
                                <p class="text-left text-sm font-normal" style="color:#808080">Email</p>
                                <p class="text-left text-base font-medium" style="color:#101010">{{
                                    paymentConfirmation?.billingInfo?.emailAddress }} </p>
                            </div>
                            <div class="flex flex-column gap-2">
                                <p class="text-left text-sm font-normal" style="color:#808080">Phone</p>
                                <p class="text-left text-base font-medium" style="color:#101010">{{
                                    paymentConfirmation?.billingInfo?.phoneNumber }} </p>
                            </div>
                            <div class="flex flex-column gap-2">
                                <p class="text-left text-sm font-normal" style="color:#808080">Address</p>
                                <p class="text-left text-base font-medium" style="color:#101010">{{
                                    paymentConfirmation?.billingInfo?.billingAddress }} </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-6">
                        <h3 class="font-semibold mb-3">Account Information</h3>
                        <div class="info-section flex flex-column gap-3">
                            <div class="flex flex-column gap-2" *ngIf="paymentConfirmation?.accountInfo?.accountHolder">
                                <p class="text-left text-sm font-normal" style="color:#808080">Account Holder</p>
                                <p class="text-left text-base font-medium" style="color:#101010">{{
                                    paymentConfirmation?.accountInfo?.accountHolder }} </p>
                            </div>
                            <div class="flex flex-column gap-2">
                                <p class="text-left text-sm font-normal" style="color:#808080">Registered Email</p>
                                <p class="text-left text-base font-medium" style="color:#101010">{{
                                    paymentConfirmation?.accountInfo?.registeredEmail }} </p>
                            </div>
                            <div class="flex flex-column gap-2">
                                <p class="text-left text-sm font-normal" style="color:#808080">Registration Date</p>
                                <p class="text-left text-base font-medium" style="color:#101010">{{
                                    paymentConfirmation?.accountInfo?.registrationDate }} </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="order-details mb-4 py-3 border-y-1 border-bluegray-100 flex flex-column gap-4">
                    <h3 class="font-medium text-xl">Order Summary</h3>
                    <div
                        class="w-full flex flex-column sm:flex-row justify-content-between align-items-start sm:align-items-end gap-3">
                        <div class="flex flex-column gap-2" style="flex: 1;">
                            <h4 class="font-medium text-lg" style="color: #101010;">{{
                                paymentConfirmation?.orderSummary?.testName }}</h4>
                            <p class="text-sm text-500" style="color: #505050;">Comprehensive career assessment and
                                personality assessment</p>
                        </div>
                        <div class="flex-shrink-0">
                            <p class="font-semibold text-base white-space-nowrap" style="color: #101010;">
                                <i class="pi pi-indian-rupee" style="font-size: 0.7rem; margin-right: 2px;"></i>{{
                                paymentConfirmation?.orderSummary?.subtotal?.toFixed(2) }}
                            </p>
                        </div>
                    </div>

                    <div class="price-summary flex flex-column gap-2 pt-3 border-top-1 border-bluegray-100">
                        <div class="flex justify-content-between align-items-center">
                            <span>Subtotal</span>
                            <span class="white-space-nowrap">
                                <i class="pi pi-indian-rupee" style="font-size: 0.7rem; margin-right: 2px;"></i>
                                {{ paymentConfirmation?.orderSummary?.subtotal?.toFixed(2) }}
                            </span>
                        </div>
                        <div class="flex justify-content-between align-items-center">
                            <span>Tax</span>
                            <span class="white-space-nowrap">
                                <i class="pi pi-indian-rupee" style="font-size: 0.7rem; margin-right: 2px;"></i>{{
                                paymentConfirmation?.orderSummary?.tax?.toFixed(2) }}
                            </span>
                        </div>

                        <div class="flex justify-content-between align-items-center mt-4">
                            <span class="text-xl font-bold">Total Paid</span>
                            <span class="text-xl font-bold text-primary white-space-nowrap">
                                <i class="pi pi-indian-rupee" style="font-size: 0.9rem; margin-right: 2px;"></i>{{
                                paymentConfirmation?.orderSummary?.total?.toFixed(2) }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="payment-method-info p-3 border-round mb-4" style="background-color: #f0f9ff;">
                    <div class="flex flex-column lg:flex-row gap-3 justify-content-between">
                        <div class="flex flex-column gap-2">
                            <p class="text-sm text-500 mb-1">Payment Method</p>
                            <p class="font-semibold">{{ paymentConfirmation?.paymentMethod }}</p>
                        </div>
                        <div class="flex flex-column gap-2 align-items-start lg:align-items-end">
                            <p class="text-sm text-500 mb-1">Payment Date</p>
                            <p class="font-semibold">{{ paymentConfirmation?.paymentDate }}</p>
                        </div>
                    </div>
                </div>

            </p-card>
            <div
                class="download-section mb-4 pt-3 border-top-1 border-bluegray-100 flex flex-column lg:flex-row justify-content-between gap-3 align-items-center">
                <div class="flex flex-column gap-2">
                    <h3 class=" font-semibold">Download Your Receipt</h3>
                    <p class="text-sm text-500">Keep a copy of your payment confirmation and order details for your
                        records</p>
                </div>
                <p-button label="Download Receipt" icon="pi pi-download" (click)="downloadReceipt()"
                    styleClass="px-4 download_btn w-full lg:w-auto"></p-button>
            </div>
        </div>
    </div>
</div>